var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editor",staticStyle:{"border":"1px solid #ccc"}})
}
var staticRenderFns = []

export { render, staticRenderFns }